<template>
  <div class="foot">
    <!--  pc端  -->
    <div v-if="screenWidth > 1080">
      <div class="foot-container">
        <div class="foot-left">
          <img class="foot-logo" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/header-logo.png" />
          <div class="tag">
            <div class="tag-title">欧洲科技 服务中国</div>
            <div class="tag-name">欧洲智慧农业富裕中国亿万良田!</div>
          </div>
        </div>

        <div class="foot-right">
          <div class="right-item" @click="goPage('1')" :class="[this.activeIndex === '1' ? 'right-item-active' : '']">网站首页</div>
          <div class="right-item" @click="goPage('2')" :class="[this.activeIndex === '2' ? 'right-item-active' : '']">关于欧力泰</div>
          <div class="right-item" @click="goPage('3')" :class="[this.activeIndex === '3' ? 'right-item-active' : '']">明星产品</div>
          <div class="right-item" @click="goPage('4')" :class="[this.activeIndex === '4' ? 'right-item-active' : '']">新闻动态</div>
          <div class="right-item" @click="goPage('5')" :class="[this.activeIndex === '5' ? 'right-item-active' : '']">联系我们</div>

        </div>
      </div>

      <div class="copyright">荷兰欧力泰植物营养科技有限公司 中国运营商：河北正达生态农业科技有限公司
        服务热线：400-666-5628 网站备案号:冀ICP备2024075434号-3
      </div>
    </div>
    <div v-else>
      <div class="foot-container">
        <div class="foot-left">
          <img class="foot-logo" src="https://olt-img.oss-cn-beijing.aliyuncs.com/header/header-logo.png" />
          <div class="tag">
            <div class="tag-title2">欧洲科技 服务中国</div>
            <div class="tag-name2">欧洲智慧农业富裕中国亿万良田!</div>
          </div>
        </div>
        <div class="foot-right2">
          <div class="right-item" @click="goPage('1')" :class="[this.activeIndex === '1' ? 'right-item-active' : '']">网站首页</div>
          <div class="right-item" @click="goPage('2')" :class="[this.activeIndex === '2' ? 'right-item-active' : '']">关于欧力泰</div>
          <div class="right-item" @click="goPage('3')" :class="[this.activeIndex === '3' ? 'right-item-active' : '']">明星产品</div>
          <div class="right-item" @click="goPage('4')" :class="[this.activeIndex === '4' ? 'right-item-active' : '']">新闻动态</div>
          <div class="right-item" @click="goPage('5')" :class="[this.activeIndex === '5' ? 'right-item-active' : '']">联系我们</div>

        </div>

      </div>
      <div class="copyright2">
        <div>荷兰欧力泰植物营养科技有限公司</div>
        <div>中国运营商：河北正达生态农业科技有限公司</div>
        <div>服务热线：400-666-5628 网站备案号:冀ICP备2024075434号-3</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  mounted() {
    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth);
    this.setSize();
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };

  },
  methods: {
    goPage(key) {
      if (key === '1' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/', query:{activeIndex: key} })
      }else if(key === '2' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/olt', query:{activeIndex: key} })
      } else if (key === '3' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/star', query:{activeIndex: key} })
      }else if(key === '4' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/news', query:{activeIndex: key} })
      } else if (key === '5' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/contact', query:{activeIndex: key} })
      }
    },
    setSize() {
      // 通过屏幕宽度(图片宽度)计算高度
      if (this.screenWidth > 1024) {
        this.paddingWidth = (200 / 1920 * this.screenWidth) + 'px';
        console.log(this.paddingWidth);
      }
    },
  },
  data() {
    return {
      screenWidth: 0,
      paddingWidth: '',
      activeIndex: this.$route.query.activeIndex ? this.$route.query.activeIndex : '1',
    }
  }
}
</script>
<style scoped lang="scss">


.foot-right {
  width: 40%;
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);

  .right-item {
    cursor: pointer;
    color: #000000;
  }

  .right-item-active {
    color: #0D8D2A;
  }
}

.foot-right2 {
  width: 35%;
  display: grid;
  gap: 1px;
  grid-template-columns: repeat(2, 1fr);

  .right-item {
    cursor: pointer;
    color: #000000;
  }

  .right-item-active {
    color: #0D8D2A;
  }
}

.foot {
  background: #E9E9E9;
}

.copyright {
  color: #878787;
  text-align: center;
  font-size: 15px;
  padding-bottom: 40px;
}

.copyright2 {
  color: #878787;
  text-align: center;
  font-size: 15px;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 70px;
  padding-right: 70px;
}

.foot-container {
  display: flex;
  justify-content: space-between;
  padding: 28px clamp(10px, 6%, 260px) 57px;
}

.foot-left {
  display: flex;
  align-items: center;
}

.foot-logo {
  height: 75px;
  width: 54px;
}

.tag-title {
  color: #0D8D2A;
  font-size: 28px;
}

.tag-name {
  font-family: "Noto Sans SC";
  color: #000000;
  font-weight: 500;
  font-size: 28px;
}

.tag-title2 {
  color: #0D8D2A;
  font-size: 16px;
}

.tag-name2 {
  font-family: "Noto Sans SC";
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}

.tag {
  margin-left: 31px;
}

@media (max-width: 1080px) {
  .foot-container {
    display: flex;
    justify-content: space-between;
    padding: 28px clamp(10px, 3%, 260px) 57px;
    padding-top: 40px;
    padding-bottom: 30px;
  }


  .tag {
    margin-left: 18px;
  }

  .foot-left {
    width: 50%;

  }

  .foot-logo {
    height: 75px;
    width: 54px;
  }

}
</style>
